import React from 'react'
import * as ReactDOMClient from 'react-dom/client'
import { setupSentry } from './setup/sentry'
import BrowserApp from './BrowserApp'

// We need to setup Sentry for the web app only.
// For Electron, we use the Electron version of Sentry.
setupSentry()

const rootElement = document.querySelector('#app')


// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = ReactDOMClient.createRoot(rootElement!)

root.render(<BrowserApp data-testid='ready' />)


if (module.hot) {
  module.hot.accept()
}
